import { render, staticRenderFns } from "./CHeaderBtn.vue?vue&type=template&id=282b580f&"
import script from "./CHeaderBtn.vue?vue&type=script&lang=ts&"
export * from "./CHeaderBtn.vue?vue&type=script&lang=ts&"
import style0 from "./CHeaderBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports